import gql from 'graphql-tag';

export const SET_PAID_STATUS = gql`
  mutation setPaidStatus($id: ID!) {
    setPaidStatus(id: $id)
  }
`;
